'use strict';

const jQuery = require('jquery');
const _ = require('lodash');

const FormBuilder = require('./../builder');

let ElementClass = require('./../elementClass');

FormBuilder.register('selectButton', function(config) {
    let self = {};

    self = new ElementClass(config);

    self.buttons = config.buttons;
    self.value = config.value;

    self.onClick = function() {
        let $button = jQuery(this);

        $button.siblings().removeClass('selected');

        $button.addClass('selected');
    };

    self.render = function() {
        let $div = jQuery('<div class="cloud-btn-group"></div>');
        let $label;
        let $bgColor;

        if (self.label) {
            $label = jQuery('<div class="cloud-label">' + self.label + '</label>');
            $div.append($label);
        }

        _.each(self.buttons, function(button, key) {
            let $button = jQuery('<button type="button" class="btn btn-default btn-icon-xl"></button>');

            if (_.isString(button.icon)) {
                $button.append(jQuery('<i class="icon ' + button.icon + '"></i>'));
            } else {
                $button.text(button.label || key);
            }

            if (_.isString(button.bgcolor)) {
                $bgColor = jQuery('<div class="has-bg-color ' + button.bgcolor + '"></div>');

                jQuery('body').append($bgColor);

                $button.css('background-color', $bgColor.css('background-color'));
                $button.find('i').css('color', $bgColor.css('color'));

                $bgColor.remove();
            }

            if (config.value === key) {
                $button.addClass('selected');
            }

            $button.attr('data-key', key);

            $button.on('click', self.onClick);

            $div.append($button);
        });

        return $div;
    };

    self.getData = function() {
        return self.$.find('button.selected').data('key');
    };

    return self;
});
